import React from 'react'
import pageStyles from '../CreatorsProgramPage/styles.module.css'
import Text from '../../../Text'
import { $textPrimary, $textSecondary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import SpecsTable from '../../Products/Utils/ItemSpecifications/SpecsTable'

function Step2() {
  return (
    <div className={pageStyles.stepWrapper}>
      <div className={pageStyles.stepContentWrapper}>
        <div className={pageStyles.stepTitle}>
          <Text type="heading-1">02</Text>
        </div>
        <div className={pageStyles.stepTextWrapper}>
          <Text type="heading-2" color={$textPrimary.dark}>Our team review and announce</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>After you submit your content, our team will carefully review each entry to select the most compelling and high-quality submissions. We look for creativity, engagement, and a strong representation of VRS hardware in use. Our goal is to choose creators who can best showcase the excitement and potential of sim racing with VRS products.</Text>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>We will score by the following criteria:</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Content Quality</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Creativity and Originality</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Engagement Potential</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Technical Skill</Text>
          <Spacer size={16}/>
          <Text type="large" color={$textSecondary.dark}>Brand Alignment</Text>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>Brand guidelines:</Text>
          <Spacer size={16}/>
          <SpecsTable specs={[
            { name: 'Font Body', value: 'Kanit Light' },
            { name: 'Font Titles', value: 'Kanit SemiBold' },
            { name: 'Accent/CTA color', value: 'Red (#AB0303)' },
            { name: 'Colors', value: 'Black, White, All shades of Gray' },
            { name: 'Overall aesthetics', value: 'Minimal and clean look' },
          ]} theme="dark"/>
          <Spacer size={32}/>
          <Text type="heading-4" color={$textPrimary.dark}>Announcement date</Text>
          <Spacer size={16}/>
          <SpecsTable specs={[
            { name: 'Apr 07 2025', value: 'Winners will be announced' }
          ]} theme="dark"/>
        </div>
      </div>
    </div>
  )
}

export default Step2
